module.exports = __webpack_public_path__ + "img/v17.768969d6.jpg";